var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuListStaffLivingQuarter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9,14.5c0,1.381-1.119,2.5-2.5,2.5s-2.5-1.119-2.5-2.5,1.119-2.5,2.5-2.5,2.5,1.119,2.5,2.5Zm15-9.5v17.5c0,.829-.671,1.5-1.5,1.5s-1.5-.671-1.5-1.5v-1.5H3v1.5c0,.829-.671,1.5-1.5,1.5s-1.5-.671-1.5-1.5V1.5C0,.671.671,0,1.5,0s1.5.671,1.5,1.5v4.5h7v-1c0-2.757,2.243-5,5-5h4c2.757,0,5,2.243,5,5Zm-11,1h8v-1c0-1.103-.897-2-2-2h-4c-1.103,0-2,.897-2,2v1ZM3,18h7v-1c0-2.757,2.243-5,5-5h6v-3H3v9Zm18,0v-3h-6c-1.103,0-2,.897-2,2v1h8ZM6.5,5c1.381,0,2.5-1.119,2.5-2.5S7.881,0,6.5,0s-2.5,1.119-2.5,2.5,1.119,2.5,2.5,2.5Z",
    fill: "#246abf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuListStaffLivingQuarter);
export default __webpack_public_path__ + "static/media/menu_list-staff_living_quarter.b9eee8d25c2f8bbfe4ee7c3db8cba453.svg";
export { ForwardRef as ReactComponent };